<div class="vo-summary">
  <div class="vo-card vo-summary__card" *ngIf="!isLoading">

    <!-- Bestätigung -->
    <div class="summary-intro">
      <span class="summary-success"><app-icon name="check" [size]="28" [strokeWidth]="2.5"/></span>
      <h2 class="summary-title">Vielen Dank für Ihre Anfrage!</h2>
      <p class="summary-subtitle">
        Ihre Anfrage ist bei uns eingegangen. Bitte prüfen Sie Ihre Angaben —
        so erhalten Sie passende Offerten.
      </p>
    </div>

    <!-- Korrekturfenster -->
    <div class="correction-banner" *ngIf="!isLocked">
      <app-icon name="clock" [size]="20"/>
      <p>
        Sie können Ihre Angaben noch <strong class="countdown">{{ countdown }}</strong> Minuten anpassen.
        Danach leiten wir Ihre Anfrage an unsere Partnerfirmen weiter.
      </p>
    </div>

    <div class="correction-banner is-locked" *ngIf="isLocked">
      <app-icon name="lock" [size]="20"/>
      <p>
        Ihre Anfrage wurde an unsere Partnerfirmen weitergeleitet — Änderungen sind hier nicht mehr möglich.
        Stimmt etwas nicht?
        <a href="https://www.vergleichsofferten.ch/kontakt" target="_blank" rel="noopener noreferrer">
          Support kontaktieren</a>.
      </p>
    </div>

    <div class="summary-sections" *ngIf="inquiry">

      <!-- Umzugsart: nicht änderbar, ein Wechsel wäre eine neue Anfrage -->
      <section class="summary-section">
        <div class="summary-head">
          <span class="summary-icon"><app-icon name="tag" [size]="17"/></span>
          <h3>Umzugsart</h3>
          <span class="summary-fixed">Nicht änderbar</span>
        </div>
        <div class="summary-rows">
          <div class="summary-row">
            <span class="summary-key">Leistung</span>
            <span class="summary-value">{{ inquiry.service | serviceType }}</span>
          </div>
        </div>
      </section>

      <!-- Auszug (Umzug) bzw. Objekt und Termin (Reinigung) -->
      <section class="summary-section" [class.is-editing]="editing === 'from'">
        <div class="summary-head">
          <span class="summary-icon"><app-icon [name]="isMove ? 'log-out' : 'house'" [size]="17"/></span>
          <h3>{{ isMove ? 'Auszug' : 'Objekt und Termin' }}</h3>
          <button type="button" class="summary-edit" *ngIf="!isLocked" (click)="toggleSection('from')">
            <app-icon [name]="editing === 'from' ? 'x' : 'pencil'" [size]="14"/>
            {{ editing === 'from' ? 'Schliessen' : 'Bearbeiten' }}
          </button>
        </div>

        <div class="summary-rows" *ngIf="editing !== 'from'">
          <div class="summary-row">
            <span class="summary-key">Adresse</span>
            <span class="summary-value">{{ inquiry.from_address }}</span>
          </div>
          <div class="summary-row">
            <span class="summary-key">PLZ / Ort</span>
            <span class="summary-value">{{ inquiry.from_zip }} {{ inquiry.from_city }}</span>
          </div>
          <div class="summary-row">
            <span class="summary-key">Objekt</span>
            <span class="summary-value">
              {{ inquiry.from_object_type | inquiryObjectType }} · {{ inquiry.rooms | inquiryRooms }} ·
              {{ inquiry.square_meters }} m²
            </span>
          </div>
          <div class="summary-row" *ngIf="isMove">
            <span class="summary-key">Stockwerk</span>
            <span class="summary-value">
              {{ inquiry.from_floor | inquiryFloor }}
              <span class="summary-muted">· {{ inquiry.from_has_lift ? 'Lift vorhanden' : 'kein Lift' }}</span>
            </span>
          </div>
          <div class="summary-row">
            <span class="summary-key">{{ isMove ? 'Umzugsdatum' : 'Reinigungsdatum' }}</span>
            <span class="summary-value">
              {{ inquiry.date | date:'dd.MM.yyyy' }}
              <span class="summary-muted" *ngIf="inquiry.is_date_flexible">· Datum ist flexibel</span>
            </span>
          </div>
          <div class="summary-row" *ngIf="inquiry.handover_date">
            <span class="summary-key">Wohnungsübergabe</span>
            <span class="summary-value">{{ inquiry.handover_date | date:'dd.MM.yyyy' }}</span>
          </div>
        </div>

        <form [formGroup]="draftInquiryForm" class="summary-form vo-grid" *ngIf="editing === 'from'">
          <div class="vo-field vo-field--full">
            <label class="vo-label" for="summary_from_address">Strasse und Hausnummer</label>
            <div class="vo-address__cell">
              <input id="summary_from_address" type="text" class="vo-input" formControlName="from_address"
                     #summaryFromAddress autocomplete="off" [class.is-invalid]="hasError('from_address')">
              <app-google-places-autocomplete
                [forInput]="summaryFromAddress"
                [countries]="[draftInquiryForm.controls.from_country.value.toLowerCase()]"
                (placeSelected)="onFromAddressPlaceSelected($event)"/>
            </div>
            <p class="vo-error" *ngIf="hasError('from_address')">
              <app-icon name="circle-alert" [size]="14"/>
              Dieses Feld ist erforderlich
            </p>
          </div>

          <div class="vo-field">
            <label class="vo-label" for="summary_from_zip">PLZ</label>
            <input id="summary_from_zip" type="text" class="vo-input" formControlName="from_zip"
                   [class.is-invalid]="hasError('from_zip')">
            <p class="vo-error" *ngIf="hasError('from_zip')">
              <app-icon name="circle-alert" [size]="14"/>
              Dieses Feld ist erforderlich
            </p>
          </div>

          <div class="vo-field">
            <label class="vo-label" for="summary_from_city">Ort</label>
            <input id="summary_from_city" type="text" class="vo-input" formControlName="from_city"
                   [class.is-invalid]="hasError('from_city')">
            <p class="vo-error" *ngIf="hasError('from_city')">
              <app-icon name="circle-alert" [size]="14"/>
              Dieses Feld ist erforderlich
            </p>
          </div>

          <div class="vo-field vo-field--full" *ngIf="isMove">
            <label class="vo-label" for="summary_from_country">Land</label>
            <select id="summary_from_country" class="vo-select" formControlName="from_country">
              <option *ngFor="let option of countryOptions" [value]="option.value">{{ option.label }}</option>
            </select>
          </div>

          <div class="vo-field vo-field--full">
            <span class="vo-label">Objekttyp</span>
            <div class="vo-chips">
              <button *ngFor="let option of objectTypeOptions" type="button" class="vo-chip"
                      [class.is-selected]="draftInquiryForm.controls.from_object_type.value === option.value"
                      [attr.aria-pressed]="draftInquiryForm.controls.from_object_type.value === option.value"
                      (click)="draftInquiryForm.controls.from_object_type.setValue(option.value);
                               draftInquiryForm.controls.from_object_type.markAsDirty()">
                <app-icon [name]="option.lucideIcon"/>
                {{ option.label }}
              </button>
            </div>
          </div>

          <div class="vo-field">
            <label class="vo-label" for="summary_rooms">Zimmer</label>
            <select id="summary_rooms" class="vo-select" formControlName="rooms">
              <option *ngFor="let option of roomOptions" [value]="option">{{ option | inquiryRooms }}</option>
            </select>
          </div>

          <div class="vo-field">
            <label class="vo-label" for="summary_square_meters">Wohnfläche in m²</label>
            <input id="summary_square_meters" type="number" class="vo-input" formControlName="square_meters"
                   [class.is-invalid]="hasError('square_meters')">
            <p class="vo-error" *ngIf="hasError('square_meters')">
              <app-icon name="circle-alert" [size]="14"/>
              Bitte einen Wert zwischen 10 und 500 angeben
            </p>
          </div>

          <ng-container *ngIf="isMove">
            <div class="vo-field">
              <label class="vo-label" for="summary_from_floor">Stockwerk</label>
              <select id="summary_from_floor" class="vo-select" formControlName="from_floor">
                <option *ngFor="let option of floorOptions" [value]="option">{{ option | inquiryFloor }}</option>
              </select>
            </div>

            <div class="vo-field">
              <span class="vo-label">Lift vorhanden</span>
              <div class="vo-seg">
                <button type="button" class="vo-seg__opt"
                        [class.is-selected]="draftInquiryForm.controls.from_has_lift.value === true"
                        [attr.aria-pressed]="draftInquiryForm.controls.from_has_lift.value === true"
                        (click)="setValue('from_has_lift', true)">
                  <app-icon name="arrow-up-down" [size]="16"/>
                  Mit Lift
                </button>
                <button type="button" class="vo-seg__opt"
                        [class.is-selected]="draftInquiryForm.controls.from_has_lift.value === false"
                        [attr.aria-pressed]="draftInquiryForm.controls.from_has_lift.value === false"
                        (click)="setValue('from_has_lift', false)">
                  <app-icon name="ban" [size]="16"/>
                  Ohne Lift
                </button>
              </div>
            </div>
          </ng-container>

          <div class="vo-field">
            <label class="vo-label" for="summary_date">{{ isMove ? 'Umzugsdatum' : 'Reinigungsdatum' }}</label>
            <input id="summary_date" type="date" class="vo-input" formControlName="date"
                   [class.is-invalid]="hasError('date')">
            <p class="vo-error" *ngIf="hasError('date')">
              <app-icon name="circle-alert" [size]="14"/>
              Bitte ein Datum in der Zukunft wählen
            </p>
          </div>

          <div class="vo-field">
            <label class="vo-label" for="summary_handover_date">Wohnungsübergabe</label>
            <input id="summary_handover_date" type="date" class="vo-input" formControlName="handover_date"
                   [class.is-invalid]="hasError('handover_date')">
            <p class="vo-error" *ngIf="hasError('handover_date')">
              <app-icon name="circle-alert" [size]="14"/>
              Sollte nach dem {{ isMove ? 'Umzugsdatum' : 'Reinigungsdatum' }} liegen
            </p>
          </div>

          <div class="vo-field vo-field--full">
            <label class="vo-option vo-option--check"
                   [class.is-selected]="draftInquiryForm.controls.is_date_flexible.value">
              <input type="checkbox" class="vo-sr-only" formControlName="is_date_flexible">
              <span class="vo-box" aria-hidden="true"><app-icon name="check" [size]="13" [strokeWidth]="3.5"/></span>
              <span class="vo-option__body"><span class="vo-option__title">Datum ist flexibel</span></span>
            </label>
          </div>
        </form>
      </section>

      <!-- Einzug -->
      <section class="summary-section" *ngIf="isMove" [class.is-editing]="editing === 'to'">
        <div class="summary-head">
          <span class="summary-icon"><app-icon name="log-in" [size]="17"/></span>
          <h3>Einzug</h3>
          <button type="button" class="summary-edit" *ngIf="!isLocked" (click)="toggleSection('to')">
            <app-icon [name]="editing === 'to' ? 'x' : 'pencil'" [size]="14"/>
            {{ editing === 'to' ? 'Schliessen' : 'Bearbeiten' }}
          </button>
        </div>

        <div class="summary-rows" *ngIf="editing !== 'to'">
          <div class="summary-row">
            <span class="summary-key">Adresse</span>
            <span class="summary-value">{{ inquiry.to_address }}</span>
          </div>
          <div class="summary-row">
            <span class="summary-key">PLZ / Ort</span>
            <span class="summary-value">{{ inquiry.to_zip }} {{ inquiry.to_city }}</span>
          </div>
          <div class="summary-row">
            <span class="summary-key">Objekt</span>
            <span class="summary-value">{{ inquiry.to_object_type | inquiryObjectType }}</span>
          </div>
          <div class="summary-row">
            <span class="summary-key">Stockwerk</span>
            <span class="summary-value">
              {{ inquiry.to_floor | inquiryFloor }}
              <span class="summary-muted">· {{ inquiry.to_has_lift ? 'Lift vorhanden' : 'kein Lift' }}</span>
            </span>
          </div>
        </div>

        <form [formGroup]="draftInquiryForm" class="summary-form vo-grid" *ngIf="editing === 'to'">
          <div class="vo-field vo-field--full">
            <label class="vo-label" for="summary_to_address">Strasse und Hausnummer</label>
            <div class="vo-address__cell">
              <input id="summary_to_address" type="text" class="vo-input" formControlName="to_address"
                     #summaryToAddress autocomplete="off" [class.is-invalid]="hasError('to_address')">
              <app-google-places-autocomplete
                [forInput]="summaryToAddress"
                [countries]="[draftInquiryForm.controls.to_country.value.toLowerCase()]"
                (placeSelected)="onToAddressPlaceSelected($event)"/>
            </div>
            <p class="vo-error" *ngIf="hasError('to_address')">
              <app-icon name="circle-alert" [size]="14"/>
              Dieses Feld ist erforderlich
            </p>
          </div>

          <div class="vo-field">
            <label class="vo-label" for="summary_to_zip">PLZ</label>
            <input id="summary_to_zip" type="text" class="vo-input" formControlName="to_zip"
                   [class.is-invalid]="hasError('to_zip')">
            <p class="vo-error" *ngIf="hasError('to_zip')">
              <app-icon name="circle-alert" [size]="14"/>
              Dieses Feld ist erforderlich
            </p>
          </div>

          <div class="vo-field">
            <label class="vo-label" for="summary_to_city">Ort</label>
            <input id="summary_to_city" type="text" class="vo-input" formControlName="to_city"
                   [class.is-invalid]="hasError('to_city')">
            <p class="vo-error" *ngIf="hasError('to_city')">
              <app-icon name="circle-alert" [size]="14"/>
              Dieses Feld ist erforderlich
            </p>
          </div>

          <div class="vo-field vo-field--full">
            <label class="vo-label" for="summary_to_country">Land</label>
            <select id="summary_to_country" class="vo-select" formControlName="to_country">
              <option *ngFor="let option of countryOptions" [value]="option.value">{{ option.label }}</option>
            </select>
          </div>

          <div class="vo-field vo-field--full">
            <span class="vo-label">Objekttyp</span>
            <div class="vo-chips">
              <button *ngFor="let option of objectTypeOptions" type="button" class="vo-chip"
                      [class.is-selected]="draftInquiryForm.controls.to_object_type.value === option.value"
                      [attr.aria-pressed]="draftInquiryForm.controls.to_object_type.value === option.value"
                      (click)="draftInquiryForm.controls.to_object_type.setValue(option.value);
                               draftInquiryForm.controls.to_object_type.markAsDirty()">
                <app-icon [name]="option.lucideIcon"/>
                {{ option.label }}
              </button>
            </div>
          </div>

          <div class="vo-field">
            <label class="vo-label" for="summary_to_floor">Stockwerk</label>
            <select id="summary_to_floor" class="vo-select" formControlName="to_floor">
              <option *ngFor="let option of floorOptions" [value]="option">{{ option | inquiryFloor }}</option>
            </select>
          </div>

          <div class="vo-field">
            <span class="vo-label">Lift vorhanden</span>
            <div class="vo-seg">
              <button type="button" class="vo-seg__opt"
                      [class.is-selected]="draftInquiryForm.controls.to_has_lift.value === true"
                      [attr.aria-pressed]="draftInquiryForm.controls.to_has_lift.value === true"
                      (click)="setValue('to_has_lift', true)">
                <app-icon name="arrow-up-down" [size]="16"/>
                Mit Lift
              </button>
              <button type="button" class="vo-seg__opt"
                      [class.is-selected]="draftInquiryForm.controls.to_has_lift.value === false"
                      [attr.aria-pressed]="draftInquiryForm.controls.to_has_lift.value === false"
                      (click)="setValue('to_has_lift', false)">
                <app-icon name="ban" [size]="16"/>
                Ohne Lift
              </button>
            </div>
          </div>
        </form>
      </section>

      <!-- Services -->
      <section class="summary-section" *ngIf="isMove" [class.is-editing]="editing === 'services'">
        <div class="summary-head">
          <span class="summary-icon"><app-icon name="package" [size]="17"/></span>
          <h3>Services und Bemerkungen</h3>
          <button type="button" class="summary-edit" *ngIf="!isLocked" (click)="toggleSection('services')">
            <app-icon [name]="editing === 'services' ? 'x' : 'pencil'" [size]="14"/>
            {{ editing === 'services' ? 'Schliessen' : 'Bearbeiten' }}
          </button>
        </div>

        <div class="summary-rows" *ngIf="editing !== 'services'">
          <div class="summary-row">
            <span class="summary-key">Zusatzleistungen</span>
            <span class="summary-value">
              <span class="summary-chips" *ngIf="inquiry.selected_additional_services?.length; else noServices">
                <ng-container *ngFor="let service of additionalServices">
                  <span class="summary-chip" *ngIf="inquiry.selected_additional_services?.includes(service.value)">
                    <app-icon [name]="service.lucideIcon" [size]="14"/>
                    {{ service.label }}
                  </span>
                </ng-container>
              </span>
              <ng-template #noServices><span class="summary-muted">Keine</span></ng-template>
            </span>
          </div>
          <div class="summary-row" *ngIf="inquiry.comment">
            <span class="summary-key">Bemerkung</span>
            <span class="summary-value">{{ inquiry.comment }}</span>
          </div>
        </div>

        <form [formGroup]="draftInquiryForm" class="summary-form vo-grid" *ngIf="editing === 'services'">
          <div class="vo-field vo-field--full">
            <span class="vo-label">Zusatzleistungen</span>
            <div class="vo-options">
              <button *ngFor="let service of additionalServices" type="button" class="vo-option"
                      [class.is-selected]="isSelected('selected_additional_services', service.value)"
                      [attr.aria-pressed]="isSelected('selected_additional_services', service.value)"
                      (click)="toggleValue('selected_additional_services', service.value)">
                <span class="vo-box" aria-hidden="true"><app-icon name="check" [size]="13" [strokeWidth]="3.5"/></span>
                <span class="vo-option__body">
                  <span class="vo-option__title">
                    <app-icon [name]="service.lucideIcon" [size]="16"/>
                    {{ service.label }}
                  </span>
                  <span class="vo-option__desc">{{ service.description }}</span>
                </span>
              </button>
            </div>
          </div>

          <div class="vo-field vo-field--full">
            <label class="vo-label" for="summary_comment">Bemerkung</label>
            <textarea id="summary_comment" class="vo-textarea" rows="3" formControlName="comment"></textarea>
          </div>
        </form>
      </section>

      <!-- Reinigung -->
      <section class="summary-section" *ngIf="isClean" [class.is-editing]="editing === 'cleaning'">
        <div class="summary-head">
          <span class="summary-icon"><app-icon name="brush" [size]="17"/></span>
          <h3>Reinigung</h3>
          <button type="button" class="summary-edit" *ngIf="!isLocked" (click)="toggleSection('cleaning')">
            <app-icon [name]="editing === 'cleaning' ? 'x' : 'pencil'" [size]="14"/>
            {{ editing === 'cleaning' ? 'Schliessen' : 'Bearbeiten' }}
          </button>
        </div>

        <div class="summary-rows" *ngIf="editing !== 'cleaning'">
          <div class="summary-row">
            <span class="summary-key">Bodenbeläge</span>
            <span class="summary-value">
              <span class="summary-chips" *ngIf="inquiry.floor_coverings?.length; else noCoverings">
                <ng-container *ngFor="let covering of floorCoveringsOptions">
                  <span class="summary-chip" *ngIf="inquiry.floor_coverings?.includes(covering.value)">
                    <app-icon [name]="covering.lucideIcon" [size]="14"/>
                    {{ covering.label }}
                  </span>
                </ng-container>
              </span>
              <ng-template #noCoverings><span class="summary-muted">Keine Angabe</span></ng-template>
            </span>
          </div>
          <div class="summary-row">
            <span class="summary-key">Storen</span>
            <span class="summary-value">
              <ng-container *ngFor="let option of blindsOptions">
                <ng-container *ngIf="option.value === inquiry.blinds">{{ option.label }}</ng-container>
              </ng-container>
            </span>
          </div>
          <div class="summary-row">
            <span class="summary-key">Zusätzliche Räume</span>
            <span class="summary-value">
              <span class="summary-chips" *ngIf="inquiry.additional_rooms?.length; else noRooms">
                <ng-container *ngFor="let room of additionalRoomsOptions">
                  <span class="summary-chip" *ngIf="inquiry.additional_rooms?.includes(room.value)">
                    <app-icon [name]="room.lucideIcon" [size]="14"/>
                    {{ room.label }}
                  </span>
                </ng-container>
              </span>
              <ng-template #noRooms><span class="summary-muted">Keine</span></ng-template>
            </span>
          </div>
          <div class="summary-row">
            <span class="summary-key">Nasszellen</span>
            <span class="summary-value">
              {{ inquiry.bad_wc }} × Bad/WC · {{ inquiry.dusche_ws }} × Dusche/WC ·
              {{ inquiry.nur_wc }} × nur WC · {{ inquiry.dusche_bad_wc }} × Dusche/Bad/WC
            </span>
          </div>
        </div>

        <form [formGroup]="draftInquiryForm" class="summary-form vo-grid" *ngIf="editing === 'cleaning'">
          <div class="vo-field vo-field--full">
            <span class="vo-label">Bodenbeläge</span>
            <div class="vo-chips">
              <button *ngFor="let covering of floorCoveringsOptions" type="button" class="vo-chip"
                      [class.is-selected]="isSelected('floor_coverings', covering.value)"
                      [attr.aria-pressed]="isSelected('floor_coverings', covering.value)"
                      (click)="toggleValue('floor_coverings', covering.value)">
                <app-icon [name]="covering.lucideIcon"/>
                {{ covering.label }}
              </button>
            </div>
          </div>

          <div class="vo-field vo-field--full">
            <span class="vo-label">Storen</span>
            <div class="vo-chips">
              <button *ngFor="let option of blindsOptions" type="button" class="vo-chip"
                      [class.is-selected]="draftInquiryForm.controls.blinds.value === option.value"
                      [attr.aria-pressed]="draftInquiryForm.controls.blinds.value === option.value"
                      (click)="draftInquiryForm.controls.blinds.setValue(option.value);
                               draftInquiryForm.controls.blinds.markAsDirty()">
                <app-icon [name]="option.lucideIcon"/>
                {{ option.label }}
              </button>
            </div>
          </div>

          <div class="vo-field vo-field--full">
            <span class="vo-label">Zusätzliche Räume</span>
            <div class="vo-chips">
              <button *ngFor="let room of additionalRoomsOptions" type="button" class="vo-chip"
                      [class.is-selected]="isSelected('additional_rooms', room.value)"
                      [attr.aria-pressed]="isSelected('additional_rooms', room.value)"
                      (click)="toggleValue('additional_rooms', room.value)">
                <app-icon [name]="room.lucideIcon"/>
                {{ room.label }}
              </button>
            </div>
          </div>

          <div class="vo-field">
            <label class="vo-label" for="summary_bad_wc">Bad/WC</label>
            <select id="summary_bad_wc" class="vo-select" formControlName="bad_wc">
              <option *ngFor="let option of bathroomOptions" [value]="option.value">{{ option.label }}</option>
            </select>
          </div>

          <div class="vo-field">
            <label class="vo-label" for="summary_dusche_ws">Dusche/WC</label>
            <select id="summary_dusche_ws" class="vo-select" formControlName="dusche_ws">
              <option *ngFor="let option of bathroomOptions" [value]="option.value">{{ option.label }}</option>
            </select>
          </div>

          <div class="vo-field">
            <label class="vo-label" for="summary_nur_wc">Nur WC</label>
            <select id="summary_nur_wc" class="vo-select" formControlName="nur_wc">
              <option *ngFor="let option of bathroomOptions" [value]="option.value">{{ option.label }}</option>
            </select>
          </div>

          <div class="vo-field">
            <label class="vo-label" for="summary_dusche_bad_wc">Dusche/Bad/WC</label>
            <select id="summary_dusche_bad_wc" class="vo-select" formControlName="dusche_bad_wc">
              <option *ngFor="let option of bathroomOptions" [value]="option.value">{{ option.label }}</option>
            </select>
          </div>
        </form>
      </section>

      <!-- Kontakt -->
      <section class="summary-section" [class.is-editing]="editing === 'contact'">
        <div class="summary-head">
          <span class="summary-icon"><app-icon name="mail" [size]="17"/></span>
          <h3>Kontakt</h3>
          <button type="button" class="summary-edit" *ngIf="!isLocked" (click)="toggleSection('contact')">
            <app-icon [name]="editing === 'contact' ? 'x' : 'pencil'" [size]="14"/>
            {{ editing === 'contact' ? 'Schliessen' : 'Bearbeiten' }}
          </button>
        </div>

        <div class="summary-rows" *ngIf="editing !== 'contact'">
          <div class="summary-row">
            <span class="summary-key">Name</span>
            <span class="summary-value">{{ inquiry.first_name }} {{ inquiry.last_name }}</span>
          </div>
          <div class="summary-row">
            <span class="summary-key">Telefon</span>
            <span class="summary-value">{{ inquiry.phone }}</span>
          </div>
          <div class="summary-row">
            <span class="summary-key">E-Mail</span>
            <span class="summary-value">{{ inquiry.email }}</span>
          </div>
          <div class="summary-row" *ngIf="inquiry.availability?.length">
            <span class="summary-key">Erreichbarkeit</span>
            <span class="summary-value">
              <span class="summary-chips">
                <span class="summary-chip" *ngFor="let option of inquiry.availability">
                  {{ option | inquiryAvailability }}
                </span>
              </span>
            </span>
          </div>
        </div>

        <form [formGroup]="draftInquiryForm" class="summary-form vo-grid" *ngIf="editing === 'contact'">
          <div class="vo-field">
            <label class="vo-label" for="summary_first_name">Vorname</label>
            <input id="summary_first_name" type="text" class="vo-input" formControlName="first_name"
                   [class.is-invalid]="hasError('first_name')">
            <p class="vo-error" *ngIf="hasError('first_name')">
              <app-icon name="circle-alert" [size]="14"/>
              Dieses Feld ist erforderlich
            </p>
          </div>

          <div class="vo-field">
            <label class="vo-label" for="summary_last_name">Nachname</label>
            <input id="summary_last_name" type="text" class="vo-input" formControlName="last_name"
                   [class.is-invalid]="hasError('last_name')">
            <p class="vo-error" *ngIf="hasError('last_name')">
              <app-icon name="circle-alert" [size]="14"/>
              Dieses Feld ist erforderlich
            </p>
          </div>

          <div class="vo-field">
            <label class="vo-label" for="summary_phone">Telefon</label>
            <input id="summary_phone" type="tel" class="vo-input" formControlName="phone"
                   [class.is-invalid]="hasError('phone')">
            <p class="vo-error" *ngIf="hasError('phone')">
              <app-icon name="circle-alert" [size]="14"/>
              Bitte eine gültige Telefonnummer angeben
            </p>
          </div>

          <div class="vo-field">
            <label class="vo-label" for="summary_email">E-Mail</label>
            <input id="summary_email" type="email" class="vo-input" formControlName="email"
                   [class.is-invalid]="hasError('email')">
            <p class="vo-error" *ngIf="hasError('email')">
              <app-icon name="circle-alert" [size]="14"/>
              Bitte eine gültige E-Mail-Adresse angeben
            </p>
          </div>

          <div class="vo-field vo-field--full">
            <span class="vo-label">Wann sind Sie erreichbar?</span>
            <div class="vo-chips">
              <button *ngFor="let option of availabilityOptions" type="button" class="vo-chip"
                      [class.is-selected]="isSelected('availability', option.value)"
                      [attr.aria-pressed]="isSelected('availability', option.value)"
                      (click)="toggleValue('availability', option.value)">
                <app-icon [name]="option.lucideIcon"/>
                {{ option.label }}
              </button>
            </div>
          </div>
        </form>
      </section>
    </div>

    <!-- Speicherleiste: nur wenn wirklich etwas geändert wurde -->
    <div class="summary-savebar" *ngIf="hasChanges && !isLocked">
      <p>Sie haben Angaben geändert.</p>
      <button type="button" class="vo-btn vo-btn--ghost" (click)="discardChanges()" [disabled]="isSaving">
        Verwerfen
      </button>
      <button type="button" class="vo-btn vo-btn--primary vo-btn--sm" (click)="onSubmit()" [disabled]="isSaving">
        Änderungen speichern
      </button>
    </div>

    <div class="summary-outro">
      <p>
        Wir suchen für Sie die besten Partnerfirmen und prüfen Ihre Anfrage sorgfältig.
        Sie erhalten danach per Mail Offerten, welche Sie vergleichen und online bestätigen können.
        Bei Fragen wenden Sie sich an unser
        <a href="https://www.vergleichsofferten.ch/kontakt" target="_blank" rel="noopener noreferrer"
           aria-label="Kontakt zum Support Team">Support Team</a>.
      </p>

      <a href="https://4a-lieferwagen.ch" target="_blank" rel="noopener noreferrer"
         class="vo-btn vo-btn--primary" aria-label="Noch günstiger umziehen mit 4A Lieferwagen">
        Noch günstiger umziehen
        <app-icon name="truck" [size]="18"/>
      </a>
    </div>
  </div>
</div>
